import React from 'react';
import { Badge, Label, Icon } from '@nooz-optics/nooz-components-lib';
import { withLocale } from '../../../../../utils/hocs/withLocale';
import { Disclosure } from '../../../../UI/Navigation/Disclosure/disclosure';
import { AddressCard } from '../../AddressCard/addressCard';
import {
  returnFormatedDate,
  formatContentfulComponentProps,
  openInNewTab,
  returnCurrencyCharFromCode,
} from '../../../../../utils/globals';
import { Image } from '../../../../UI/Media/Image/index';
import { ProductPrice } from '../../../../UI/Elements/Price/productPrice';
import { Button } from '../../../../UI/Elements';

export const UserLineOrderItem = withLocale(({ order, data }) => {
  const currency = returnCurrencyCharFromCode(order.node.currencyCode);

  const { dateLabel, numberLabel, viewOrderButton, fulfillment, payment } =
    data;
  const { dispatchedLabel, notDispatchedLabel, restockedLabel } =
    formatContentfulComponentProps(fulfillment);
  const {
    authorizedLabel,
    paidLabel,
    partiallyPaidLabel,
    partiallyRefundedLabel,
    pendingLabel,
    refundedLabel,
    voidedLabel,
  } = formatContentfulComponentProps(payment);

  const returnFullfillmentLabel = (fulfillmentStatus) => {
    switch (fulfillmentStatus.toLowerCase()) {
      case 'fulfilled':
        return [{ text: dispatchedLabel.text }, { classname: 'dual' }];
      case 'restocked':
        return [{ text: restockedLabel.text }, { classname: 'bluelight' }];
      default:
        return [{ text: notDispatchedLabel.text }, { classname: 'bluelight' }];
    }
  };

  const returnFinancialLabel = (financialStatus) => {
    switch (financialStatus.toLowerCase()) {
      case 'paid':
        return [{ text: paidLabel.text }, { classname: 'dual' }];
      case 'pending':
        return [{ text: pendingLabel.text }, { classname: 'bluelight' }];
      case 'authorized':
        return [{ text: authorizedLabel.text }, { classname: 'bluelight' }];
      case 'partially_paid':
        return [{ text: partiallyPaidLabel.text }, { classname: 'bluelight' }];
      case 'partially_refunded':
        return [
          { text: partiallyRefundedLabel.text },
          { classname: 'bluelight' },
        ];
      case 'refunded':
        return [{ text: refundedLabel.text }, { classname: 'bluelight' }];
      case 'voided':
        return [{ text: voidedLabel.text }, { classname: 'bluelight' }];
      default:
        return [{ text: voidedLabel.text }, { classname: 'bluelight' }];
    }
  };

  const returnOrderItemHeader = (
    orderNumber,
    processedAt,
    financialStatus,
    fulfillmentStatus
  ) => (
    <div className='w-full flex flex-col sm:items-center sm:flex-row sm:justify-between'>
      <div className='pl-flex flex-col text-left items-start'>
        <div className='flex'>
          <Label
            weight='medium'
            text={`${numberLabel.text} :`}
          />
          &nbsp;
          <Label
            weight='light'
            text={`#${orderNumber}`}
          />
        </div>
        <div className='flex'>
          <Label
            weight='medium'
            text={`${dateLabel.text} :`}
          />
          &nbsp;
          <Label
            weight='light'
            text={`${returnFormatedDate(processedAt)}`}
          />
        </div>
      </div>
      <div className='sm:flex sm:items-center pt-4 pr-6 sm:pt-0'>
        <div className='pb-2 sm:pb-0 sm:pr-4'>
          <Badge
            size='base'
            type='white'
            color={{ classname: 'primary' }}
            dotColor={returnFinancialLabel(financialStatus)[1]}
            label={returnFinancialLabel(financialStatus)[0]}
          />
        </div>
        <div>
          <Badge
            size='base'
            type='white'
            color={{ classname: 'primary' }}
            dotColor={returnFullfillmentLabel(fulfillmentStatus)[1]}
            label={returnFullfillmentLabel(fulfillmentStatus)[0]}
          />
        </div>
      </div>
    </div>
  );
  return (
    <AddressCard>
      <Disclosure
        isOpen={false}
        button={returnOrderItemHeader(
          order.node?.orderNumber,
          order.node?.processedAt,
          order.node?.financialStatus,
          order.node?.fulfillmentStatus
        )}
        chevronIcon={
          <Icon
            iconKey='HiChevronDown'
            size='2xl'
            color={{ classname: 'primary' }}
          />
        }>
        <div className='py-4'>
          {order.node.lineItems &&
            order.node.lineItems.edges &&
            order.node.lineItems.edges.map((item, index) => {
              const isLastItem =
                index === order.node.lineItems.edges.length - 1;
              if (item.node?.variant) {
                return (
                  <>
                    <div className='flex flex-col sm:flex-row justify-between'>
                      <div className='flex py-4'>
                        <div className='w-24 h-24 rounded-md border overflow-hidden object-center object-cover sm:w-24 sm:h-24'>
                          <Image
                            width='100%'
                            height='100%'
                            objectFit='cover'
                            description={item.node?.variant?.title}
                            media={{
                              file: {
                                url: item.node?.variant?.image?.originalSrc,
                              },
                            }}
                          />
                        </div>
                        <div className='w-full sm:w-72 md:w-80 lg:w-96 flex flex-1 flex-col sm:flex-row pl-6'>
                          <div className='sm:w-4/5'>
                            <Label
                              text={item.node.title}
                              size='lg'
                              weight='medium'
                              transform='capitalize'
                            />
                            <Label
                              text={item.node.variant.title}
                              size='sm'
                            />
                          </div>
                          <div className='pt-4 sm:pt-0 sm:w-1/5'>
                            <ProductPrice
                              price={{ text: item.node.variant.price }}
                              currency={{ text: currency }}
                              size='base'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLastItem && (
                      <Button
                        type='contained'
                        color={{ classname: 'black' }}
                        label={{ text: viewOrderButton.label?.text }}
                        onClick={() => openInNewTab(order.node.statusUrl)}
                      />
                    )}
                  </>
                );
              }
            })}
        </div>
      </Disclosure>
    </AddressCard>
  );
});
